import { Table } from "@bphxd/ds-core-react";

export default function QNAPagination({
  totalCount,
  pageSize,
  currentPage,
  onPageChange,
}: {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (offset: number, idx: number) => void;
}) {

  const onPageIndexChange = (index: number) => {
    onPageChange(index * pageSize, index);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "10px",
        fontSize: "14px",
      }}
    >
      <Table.Pagination
        onPageIndexChange={onPageIndexChange}
        pageIndex={currentPage}
        pageSize={pageSize}
        totalCount={totalCount}
      />
    </div>
  );
}